module.exports = __webpack_public_path__ + "img/volume_up_blue.6103eacf.svg";